import { combineReducers } from 'redux';

import { routerReducer } from 'react-router-redux';

import { localeReducer } from './locale';
import { navigationReducer } from './navigation';
import { overlaysReducer } from './overlays';
import { mediaReducer } from './media';

/**
* The userAgent state won't be set by anything
* other than the server on page load so there's
* no need for anything other than a passthru.
*/
const userAgentReducer = function(state = {}) {
  return state;
};

const abIdReducer = function(state = {}) {
  return state;
};

const inAppHeaderReducer = function(state = {}) {
  return state;
};

export default combineReducers({
  routing: routerReducer,
  locale: localeReducer,
  navigation: navigationReducer,
  userAgent: userAgentReducer,
  abId: abIdReducer,
  appHeader: inAppHeaderReducer,
  overlays: overlaysReducer,
  media: mediaReducer,
});



// WEBPACK FOOTER //
// ../src/client/state/index.js